export enum NotificationActionEnum {
    Reservation = "socialite.reservations.pending",
    Chat = "socialite.events.sendchatmessage",
}